import styled from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';
import { TYPOGRAPHY } from 'brand-guidelines/typography';

export const HoursList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:not(:last-child) {
    padding-bottom: 4px;
    border-bottom: 1px solid ${BRAND_COLORS.lightGray};
  }
`;

export const Hours = styled.p`
  font-style: normal;
  font-size: 14px;
  ${TYPOGRAPHY.OPEN_SANS.semiBold};
  text-align: right;

  color: ${(props) =>
    (props.isClosed ? BRAND_COLORS.darkStroke : BRAND_COLORS.black)};
`;

export const WeekDay = styled.div`
  font-style: normal;
  ${TYPOGRAPHY.OPEN_SANS.semiBold};
  font-size: 14px;
  display: flex;
  align-items: center;
  color: ${BRAND_COLORS.lightGreen};
`;
